export default {
    Search: 'Zoeken',
    'No results found.': 'Geen resultaten gevonden.',
    cancel: 'annuleren'
};



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/addons/searchfield/translations/nl.js
// module id = 84
// module chunks = 0